import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { filter, take } from 'rxjs/operators';

import { CookiesService } from '../cookies/cookies.service';
import { LocalStorageInterface } from './local-storage.interface';

@Injectable()
export class LocalStorage implements LocalStorageInterface {
  prefix = 'ngStorage-';
  localStorageNotAvailable = false;

  localStorage: Storage;
  $ready = new BehaviorSubject<boolean>(false);
  $isReady = this.$ready.pipe(
    filter(ready => ready),
    take(1)
  );

  cacheStorage: {
    [key: string]: any;
  } = {};

  constructor(protected cookies: CookiesService) {
    if (!localStorage) {
      this.localStorageNotAvailable = true;
      this.localStorage = (window as any).memoryStorage;
    } else {
      this.localStorage = localStorage;
    }
  }

  get ready(): boolean {
    return this.$ready.value;
  }

  getCachedItem(key: string) {
    return this.cacheStorage[key];
  }

  async getItem(key: string): Promise<any> {
    if (this.cacheStorage[key]) {
      return this.cacheStorage[key];
    }

    const value = this.parseValue(this.cookies.get(key)) || this.localStorage.getItem(key);
    this.cacheStorage[key] = value;
    return value;
  }

  async setItem(key: string, value: any): Promise<void> {
    this.localStorage.setItem(key, value);
    this.cookies.set(key, value);
    this.cacheStorage[key] = this.parseValue(value);
    return;
  }

  parseValue(value: any) {
    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  }

  removeItem(key: string) {
    this.cookies.delete(key);
    this.localStorage.removeItem(key);
    this.localStorage.removeItem(this.prefix + key);
    this.cacheStorage[key] = null;
    delete this.cacheStorage[key];
  }

  removeAll() {
    this.localStorage.clear();
    this.cookies.deleteAll();
    this.cacheStorage = {};
  }
}
